import { useState, useEffect, useContext } from "react";
import MainPanelHeader from "../../../layouts/mainPanelHeader";
import PanelRightContent from "../../../layouts/mainPanel/PanelRightContent";
import PanelLeftContent from "../../../layouts/mainPanel/PanelLeftContent";
import avatar from "../../../asset/image/avatar.png";
import { Image } from "react-bootstrap";
import { ReactComponent as CameraIcon } from "../../../asset/icons/cameraIcon.svg";
import { ReactComponent as StarIcon } from "../../../asset/icons/starIcon.svg";
import { ReactComponent as EmptyStarIcon } from "../../../asset/icons/emptyStarIcon.svg";
import ReactStars from "react-rating-stars-component";
import { Tabs, Tab, ProgressBar } from "react-bootstrap";
import {
    CircularProgressbarWithChildren,
    buildStyles,
} from "react-circular-progressbar";
import Personal from "./Personal";
import Education from "./Education";
import City from "./City";
import Job from "./Job";
import User from "./User";
import "./style.scss";
import { get, patch } from "../../../controlers/global/ConfigRequest";
import {
    GET_USER_PROFILE,
    EDIT_PROFILE_DATA,
} from "../../../helperData/ApiAddress";
import { ToastContext } from "../../../component/global/ToastContext";
import { ReactComponent as DidebanLogo } from "../../../asset/icons/dideban_logo_blue.svg";
import { memo } from "react";
import { useTranslation } from "react-i18next";

function UserProfile() {
    const [activeTab, setActiveTab] = useState();
    const [completeProfile, setComleteProfile] = useState(50);
    const [profileData, setProfileData] = useState({});
    const [editedProfileData, setEditedProfileData] = useState(null);
    const [refreshMode, setRefreshMode] = useState(false);
    const [loading, setLoading] = useState(true);
    const [spLoader, setSpLoader] = useState(false);
    const show = useContext(ToastContext);
    const { t } = useTranslation();

    const getUserProfileInfo = () => {
        setLoading(true);
        get(GET_USER_PROFILE).then((r) => {
            setProfileData(r);
            setLoading(false);
        });
    };

    const editedDataHandler = (e, data) => {
        e.preventDefault();
        setEditedProfileData(data);
    };

    const sendEditedData = () => {
        setSpLoader(true);
        patch(EDIT_PROFILE_DATA, editedProfileData)
            .then((r) => {
                setRefreshMode(!refreshMode);
                setEditedProfileData(null);
                setSpLoader(false);
                show(t("Src.Pages.UserPages.UserProfile.Success"), "success");
            })
            .catch(() => {
                show(t("Src.Pages.UserPages.UserProfile.Danger"), "danger");
                setSpLoader(false);
            });
    };

    useEffect(() => {
        getUserProfileInfo();
    }, [refreshMode]);

    useEffect(() => {
        if (editedProfileData !== null) {
            sendEditedData();
        }
    }, [editedProfileData]);

    return (
        <div id="user-profile" className=" main_panel_box user-profile">
            <MainPanelHeader />
            <div className="user-profile_content main_panel_content">
                <PanelRightContent>
                    {loading ? (
                        <div className="dideban-loading">
                            <DidebanLogo />
                        </div>
                    ) : (
                        <div className="tab-section">
                            <Tabs
                                activeKey={activeTab}
                                transition={false}
                                className="panel_tab"
                                onSelect={(e) => setActiveTab(e)}
                            >
                                <Tab
                                    eventKey="1"
                                    className="panel_tab_item"
                                    title={t(
                                        "UserPanel.Profile.PersonalInfo.Tab"
                                    )}
                                >
                                    <Personal
                                        data={profileData}
                                        editedDataHandler={editedDataHandler}
                                        spLoader={spLoader}
                                    />
                                </Tab>
                                <Tab
                                    eventKey="2"
                                    className="panel_tab_item"
                                    title={t(
                                        "UserPanel.Profile.EducationalInfo.Tab"
                                    )}
                                >
                                    <Education
                                        data={profileData}
                                        editedDataHandler={editedDataHandler}
                                        spLoader={spLoader}
                                    />
                                </Tab>
                                <Tab
                                    eventKey="3"
                                    className="panel_tab_item"
                                    title={t(
                                        "UserPanel.Profile.LivingPlaceInfo.Tab"
                                    )}
                                >
                                    <City
                                        data={profileData}
                                        editedDataHandler={editedDataHandler}
                                        spLoader={spLoader}
                                    />
                                </Tab>
                                <Tab
                                    eventKey="4"
                                    className="panel_tab_item"
                                    title={t(
                                        "UserPanel.Profile.OccupationInfo.Tab"
                                    )}
                                >
                                    <Job
                                        data={profileData}
                                        editedDataHandler={editedDataHandler}
                                        spLoader={spLoader}
                                    />
                                </Tab>
                                <Tab
                                    eventKey="5"
                                    className="panel_tab_item"
                                    title={t("UserPanel.Profile.UserInfo.Tab")}
                                >
                                    <User
                                        data={profileData}
                                        editedDataHandler={editedDataHandler}
                                        spLoader={spLoader}
                                    />
                                </Tab>
                            </Tabs>
                        </div>
                    )}
                </PanelRightContent>
                <PanelLeftContent>
                    <div id="user-profile-info">
                        {/* <div className="avatar-section">
                            <div className="percent">{completeProfile}%</div>
                            <div className="avatar-image">
                                <div className="avatar-border"></div>
                                <CircularProgressbarWithChildren
                                    value={completeProfile}
                                    counterClockwise
                                    strokeWidth={4}
                                    styles={buildStyles({
                                        strokeLinecap: "butt",
                                    })}
                                >
                                    <Image src={avatar} alt="avatar" />
                                </CircularProgressbarWithChildren>

                                <div className="add-avatar">
                                    <CameraIcon />
                                </div>
                            </div>
                            <div className="activity">
                                {t("UserPanel.Profile.UserStatus.Active.Label")}
                            </div>
                        </div> */}
                        <div className="name">
                            {sessionStorage.first_name}{" "}
                            {sessionStorage.last_name}
                        </div>
                        {/* <div className="rating-stars">
                            <ReactStars
                                edit={false}
                                value={5}
                                count={5}
                                size={24}
                                activeColor="#FEB730"
                                filledIcon={<StarIcon />}
                                emptyIcon={<EmptyStarIcon />}
                            />
                        </div> */}
                        {/* <div className="bio">
                            ورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت
                            چاپ و با استفاده از طراحان گرافیک است. چاپگرها و
                            متون بلکه روزنامه و مجله در ستون
                        </div> */}
                        <div className="score-section">
                            <div className="score-title">
                                <div>مجموع امتیاز : 1550</div>
                                <div>فیدیما کوشا</div>
                            </div>
                            <ProgressBar>
                                <ProgressBar now={10} key={1} />
                                <ProgressBar now={20} key={2} />
                                <ProgressBar now={20} key={3} />
                                <ProgressBar now={20} key={4} />
                                <ProgressBar now={0} key={5} />
                                <ProgressBar now={0} key={6} />
                            </ProgressBar>
                            <div className="progress-caption">
                                <div>100</div>
                                <div>500</div>
                                <div>1000</div>
                                <div>1500</div>
                                <div>3000</div>
                            </div>
                        </div>
                        <div className="contact-info">
                            <div>
                                {sessionStorage.username?.replace("+98", "0")}
                            </div>
                            <div>{sessionStorage.email}</div>
                            {/* <div>البرز ، ایران</div> */}
                            {/* <a href="#">
                                {t("UserPanel.Profile.ChangePassword.Button")}
                            </a> */}
                        </div>
                    </div>
                </PanelLeftContent>
            </div>
        </div>
    );
}

export default memo(UserProfile);
